export const getProjectConfig = (state) => state.projectConfig;
